<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <em class="fa fa-warning fa-lg text-danger"></em>
    <span class="font-bold text-danger pl-3" i18n="@@animalsNotAdded">
      The animals with the numbers below already exist in our database. As a result, they were removed from the removal request.
    </span>

    <ul>
      <li *ngFor="let d of data">{{d?.number}}</li>
    </ul>
  </div>
</div>
